import styled from "styled-components";
import { rem, em } from "convert-to-ems";

export const InfoBenefitContainerCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${rem(260)};
  height: ${rem(140)};
  border-top-left-radius: ${rem(8)};
  border-top-right-radius: ${rem(8)};
  background-color: ${props => props.backgroundCell};
`;

export const InfoBenefitContainerCellImg = styled.img`
  border-top-left-radius: ${rem(8)};
  border-top-right-radius: ${rem(8)};
  width: ${rem(260)};
  height: ${rem(140)};
`;

export const InfoBenefitContainerContent = styled.div`
  width: ${rem(260)};
  padding: ${rem(24)};
  background-color: ${props => props.backgroundContainer};
`;

export const InfoBenefitContainerContentTitle = styled.div`
  font-size: ${em(25)};
  font-weight: 700;
  white-space: pre-wrap;
`;

export const InfoBenefitContainerContentDescription = styled.div`
  min-height: ${em(80)};
  margin-top: ${em(12)};
  font-family: ${props => props.theme.baseFontFamily};
  font-size: ${em(16)};
  color: #51555d;
  font-weight: 400;
`;
